import React, { useState } from 'react'
import './Dashboard.css'
import ChangePassword from './Profile/ChangePassword'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SEO from '@/utils/SEO'
import { Button } from '@material-ui/core'
import DashboardLayout from './DashboardLayout'
import { NavLink, useHistory, useLocation } from 'react-router-dom'
import { handleRedirectInternal } from '@/product/common/components'

const PasswordSecurity = (props) => {
    const history = useHistory()
    return (
        <>
            <DashboardLayout title={'Password & Security'}>
                <SEO title="Password & Security" url={window.location.href} />
                <div className="maTitle d-flex justify-content-between align-items-center w-100">
                    <Button
                        onClick={() => {
                            handleRedirectInternal(history, 'my-account')
                        }}
                        className="moveBack"
                    >
                        <span className="material-icons">keyboard_arrow_left</span>
                        {'Back to Account'}
                    </Button>
                </div>
                <div className="dashboardInner">
                    <h1 className="title mb-3 text-center">ACCOUNT SECURITY</h1>
                    <div className="accSecurity row mt-5">
                        <div className="changePassSection col-md-5 col-12">
                            <h1 className="mb-3">CHANGE PASSWORD</h1>
                            <ChangePassword />
                        </div>
                        <div className="changePassSection col-md-5 col-12">
                            <h1 className="mb-3">PAYMENT METHODS</h1>
                            <p className="mb-md-5">
                                Zipperbuy does not store your full credit card information, only the
                                last four digits are viewable. We work with a third party system to
                                encrypt and secure your payment information. Click below to manage
                                your cards on file.
                            </p>
                            <PrimaryButton
                                type="submit"
                                btnSize="small"
                                label="Manage Credit Cards"
                                onClick={() =>
                                    handleRedirectInternal(history, 'payments/saved_cards')
                                }
                            />
                        </div>
                        <div className="changePassSection col-md-5 col-12">
                            <h1 className="mb-3">INACTIVATE ACCOUNT</h1>
                            <p className="mb-md-5">
                                Inactivating your account will disable the Buy Now and Offer
                                features with this username. If you suspect fraud on your account,
                                would like to inactivate your username, or have any other concerns,
                                please contact our support team.
                            </p>
                            <PrimaryButton
                                onClick={() => handleRedirectInternal(history, 'contact-us')}
                                btnSize="small"
                                label="Contact Support"
                            />
                        </div>
                        <div className="changePassSection col-md-5 col-12">
                            {/* <h1 className="mb-3">CURRENT DEVICES</h1>
                            <p className="mb-md-5">
                                Alli&apos;s iPhone 9/9/24 6:09PM from
                                <br /> Columbus, OH
                                <br /> Dell laptop 9/8/24 7:15AM from
                                <br /> Westerville, OH
                            </p>
                            <PrimaryButton
                                type="submit"
                                btnSize="small"
                                label="Sign Out On All Devices"
                            /> */}
                        </div>
                    </div>
                </div>
            </DashboardLayout>
        </>
    )
}

export default PasswordSecurity
